import createTypes from 'redux-create-action-types';

export default createTypes('GET_FEEDBACKS', 'SUCCESS_GET_FEEDBACKS', 'FAILURE_GET_FEEDBACKS');